import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

const TimeDisplay = ({
  value,
  C,
  fontForLetter,
  fontForSecondDigit,
  styles,
  alreadyConverted,
  colorAlreadyParsed,
  convertTime,
  font,
  scale,
  color = 'Label/Light/Tertiary',
  fontForDelimiter = 'Caption 1',
  fontForDigit = 'Time 6',
  showPlus = false,
}) => {
  const valueIsNumber = typeof value === 'number';
  const valueIsString = typeof value === 'string';

  const parsedColor = colorAlreadyParsed ? color : C(color);

  const isNegative = valueIsNumber && value < 0;
  const isPositiveWithPlus = valueIsNumber && value >= 0 && showPlus;
  const absoluteValue = isNegative ? Math.abs(value) : value;

  const gte100Hours = valueIsNumber ? absoluteValue >= 100 * 60 * 60 : false;
  const gte1000Hours = valueIsNumber ? absoluteValue >= 1000 * 60 * 60 : false;

  if (gte100Hours && valueIsNumber) {
    const formattedValue = gte1000Hours ? '+999' : Math.floor(absoluteValue / 60 / 60);

    return (
      <View style={[{ flexDirection: 'row', alignItems: 'baseline' }, styles]}>
        {isNegative && <Text style={[font[fontForDelimiter], { fontSize: scale(11), color: parsedColor }]}>-</Text>}
        {isPositiveWithPlus && <Text style={[font[fontForDelimiter], { fontSize: scale(11), color: parsedColor }]}>+</Text>}
        <Text style={[font[fontForDigit], { fontSize: scale(11), color: parsedColor }]}>{formattedValue}</Text>
        <Text style={[font[fontForLetter ?? 'Caption 1'], { fontSize: scale(11), color: parsedColor, includeFontPadding: true }]}>{i18n.t('h')}</Text>
      </View>
    );
  }

  const formattedValue = alreadyConverted && valueIsString ? value : convertTime(absoluteValue);
  const delimiter = ':';
  const timeParts = formattedValue.split(delimiter);

  return (
    <View style={[{ flexDirection: 'row', alignItems: 'baseline' }, styles]}>
      {isNegative && <Text style={[font[fontForDelimiter], { fontSize: scale(11), color: parsedColor }]}>-</Text>}
      {isPositiveWithPlus && <Text style={[font[fontForDelimiter], { fontSize: scale(11), color: parsedColor }]}>+</Text>}
      {timeParts.map((part, index) => {
        const lastPart = index === timeParts.length - 1;
        const size = lastPart ? 9 : 11;

        return (
          <View key={index} style={{ flexDirection: 'row', alignItems: 'baseline' }}>
            <Text style={[font[fontForDigit], { color: parsedColor, fontSize: scale(size) }, lastPart && { fontVariant: ['tabular-nums'] }]}>
              {part}
            </Text>
            {!lastPart && <Text style={[font[fontForDelimiter], { fontSize: scale(9), color: parsedColor, alignSelf: 'center' }]}>{delimiter}</Text>}
          </View>
        );
      })}
    </View>
  );
};

export default TimeDisplay;
